import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import _ from 'underscore';

import { Manifest } from 'services/action';
import { Page, Button } from 'ui/components';
import {
  FormAir,
  FormGeneral,
  FormJob,
  FormLand,
  FormMap,
  FormRouting,
  FormSea,
} from './component/form';
import { UTCFormat } from 'utilities/common';

const initialState = {
  data: null,
  form: null,
  moda: null,
  selected: [],
  ready: false,
  sum: {
    weight: 0,
    quantity: 0,
  },
};

const UpdateScreen = ({ match }) => {
  const Dispatch = useDispatch();
  const History = useHistory();
  const Session = useSelector((state) => state?.Auth?.session);
  const StateForm = useSelector((state) => state?.Form);
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Manifest.Show']
  );

  const [{ moda, form, selected, sum, ready, data }, setState] =
    React.useState(initialState);
  const [, forceUpdate] = React.useReducer((x) => x + 1, 0);

  const $handleSubmit = async () => {
    const payload = {
      shipping_method: form?.shipping_method,
      moda_type: form?.moda_type,
      schedule_at: form?.schedule_at,
      vendor_id: form?.vendor_id,
      total_cost: form?.total_cost,
    };

    let items = [];

    if (selected !== null) {
      selected?.forEach((item) => {
        items.push({
          job_id: item?.id,
        });
      });
    }

    if (!Session?.hub) {
      if (form?.type === 'pickup') {
        payload.destination_id = form?.destination?.id;
      }

      if (form?.type === 'last_mile' || form?.type === 'return' || form?.type === 'forwarder') {
        payload.origin_id = form?.origin?.id;
      }

      if (form?.type === 'console') {
        payload.origin_id = form?.origin?.id;
        payload.destination_id = form?.destination?.id;
      }
    } else {
      if (form?.type === 'console') {
        payload.destination_id = form?.destination?.id;
      }
    }

    if (items) {
      payload.jobs = items;
    }

    if (form?.shipping_method === 'inhouse') {
      payload.type = form?.type;
    }

    if (form?.shipping_method === 'external') {
      payload.type = 'forwarder';
      payload.is_with_console = form?.is_with_console;

      if (form?.is_with_console) {
        payload.destination_id = form?.destination?.id;
      }
    }

    if (form?.moda_type === 'land_freight') {
      payload.land_freight = {
        driver_id: moda?.driver_id,
        vehicle_id: moda?.vehicle_id,
        vehicle_type_id: moda?.vehicle_type_id,
        name: moda?.name,
        phone_number: moda?.phone_number,
        vehicle_number: moda?.vehicle_number,
        bank_account: moda?.bank_account,
      };
    }

    if (form?.moda_type === 'air_freight') {
      payload.air_freight = {
        airplane: moda?.airplane,
        code_smu: moda?.code_smu,
        date: UTCFormat(moda?.date?.formatted, moda?.date_time, true),
        etd: UTCFormat(moda?.etd?.formatted, moda?.etd_time, true),
        no_manifest: moda?.no_manifest,
      };
    }

    if (form?.moda_type === 'sea_freight') {
      payload.sea_freight = {
        bl_code: moda?.bl_code,
        no_container: moda?.no_container,
        no_vessel: moda?.no_vessel,
      };
    }

    const req = await Dispatch(Manifest.$update(data?.id, payload));

    if (req?.message === 'success') {
      History.push(`/manifest/${data?.id}`);
    }
  };

  const $handleFormChange = (v) => {
    setState((prevState) => ({ ...prevState, form: v }));
  };

  const $handleModaChange = (v) => {
    setState((prevState) => ({ ...prevState, moda: v }));
  };

  const $handleJobSelected = (v) => {
    let tw = _.reduce(
      v,
      function (sum, item) {
        return sum + item?.delivery_order?.shipment?.total_weight;
      },
      0
    );

    let tq = _.reduce(
      v,
      function (sum, item) {
        return sum + item?.delivery_order?.shipment?.total_quantity;
      },
      0
    );

    setState((prevState) => ({
      ...prevState,
      selected: v,
      sum: {
        weight: tw,
        quantity: tq,
      },
    }));
    forceUpdate();
  };

  const $handleJobSorted = (v) => {
    setState((prevState) => ({
      ...prevState,
      selected: v,
    }));
    forceUpdate();
  };



  React.useEffect(() => {
    const $onLoad = async (id) => {
      const req = await Dispatch(Manifest.$show(id));

      if (req?.message === 'success' && req?.data !== null) {
        setState((prevState) => ({
          ...prevState,
          data: req?.data,
          ready: true,
        }));
      }
    };

    if (!ready) $onLoad(match?.params?.id);
  }, []);

  if (!data) return null;

  return (
    <Page type="form" className="bg-white" onSubmit={$handleSubmit}>
      <Page.Header
        title="Perbaharui Manifest"
        className="bg-light"
        backTo="/manifest"
      />
      <Page.Body className="bg-light border-top">
        <div className="bg-white p-2 border-bottom">
          <div className="row">
            <div className="col-md-6">
              <FormGeneral
                initialValue={data}
                onValueChange={$handleFormChange}
                onUpdate={data}
              />
            </div>
            <div className="col-md-6">
              {form?.moda_type === 'land_freight' && (
                <FormLand
                  initialValue={data?.moda?.land_freight || data?.console?.moda?.land_freight}
                  onValueChange={$handleModaChange}
                  vendor={form?.vendor_id}
                />
              )}
              {form?.moda_type === 'sea_freight' && (
                <FormSea
                  initialValue={data?.moda?.sea_freight || data?.console?.moda?.sea_freight}
                  onValueChange={$handleModaChange}
                />
              )}

              {form?.moda_type === 'air_freight' && (
                <FormAir
                  initialValue={data?.moda?.air_freight || data?.console?.moda?.air_freight}
                  onValueChange={$handleModaChange}
                />
              )}
            </div>
          </div>
        </div>

        {!StateLoading && (
          <div className="p-3">
            <div className="row">
              <div className="col-md-6">
                {(form?.type || data?.type) && (
                  <FormJob
                    type={
                      form?.type === 'return' || form?.type === 'forwarder'
                        ? 'last_mile'
                        : form?.type
                    }
                    manifest={data}
                    onSelected={$handleJobSelected}
                    destination={form?.destination}
                    origin={form?.origin}
                    selected={selected}
                  />
                )}
              </div>
              <div className="col-md-6">
                <FormMap
                  type={
                    form?.type === 'return' || form?.type === 'forwarder'
                        ? 'last_mile'
                        : form?.type
                  }
                  origin={form?.origin}
                  destination={form?.destination}
                  routing={selected}
                  isLoading={StateLoading}
                  sum={sum}
                />
                <FormRouting
                  type={
                    form?.type === 'return' || form?.type === 'forwarder'
                      ? 'last_mile'
                      : form?.type
                  }
                  originalData={selected}
                  onChanges={$handleJobSorted}
                  onDelete={$handleJobSelected}
                />
              </div>
            </div>
          </div>
        )}
      </Page.Body>
      <Page.Footer className="padding d-grid gap-2 d-md-flex justify-content-md-center">
        <Button
          type="button"
          className="btn-secondary py-md-2"
          onClick={() => {
            History.replace(`/manifest`);
          }}
        >
          Batal &amp; Kembali
        </Button>
        <Button
          type="submit"
          loading={StateForm?.loading}
          className="btn-primary py-md-2"
        >
          Simpan
        </Button>
      </Page.Footer>
    </Page>
  );
};

export default UpdateScreen;
